import React from 'react';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state/index';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem'

class Item extends React.Component {
  render() {
    const { classes } = this.props;
      return (
        <div {...this.props}>
          {this.props.item.activo &&
          <div  onClick={this.props.onClick} className='containerItemRubro sortable-list'>
            <div className='imgNombre'>
              {(this.props.item.imagen !== undefined) &&
                <img src={this.props.item.imagen}  onDragStart={(e)=>{e.preventDefault();}} alt=""/>}
              <div>{this.props.item.nombre}</div>
            </div>
            {(this.props.mapToItem((x) => x.opciones) !== undefined) &&
              <div onClick={(e)=>{e.stopPropagation()}}>
                <PopupState variant="popover" popupId={"nuevo-usuario-menu"}>
                  {popupState => (
                    <React.Fragment>
                      <IconButton {...bindTrigger(popupState)}>
                        <MoreVertIcon />
                      </IconButton>
                      <Menu {...bindMenu(popupState)}>
                        {
                          this.props.item.opciones.map((x)=>{return x!==undefined ? <MenuItem onClick={(...args)=>{x.handler(...args);popupState.close(...args)}}>{x.nombre}</MenuItem> : undefined})
                        }
                      </Menu>
                    </React.Fragment>
                  )}
                </PopupState>
              </div>
            }
            {(this.props.item.activo !== true) && <div style={{float:"right", fontWeight:"normal", position:"relative",fontFamily:"Roboto",color:"#FFFFFF", backgroundColor:"#E21B1B", borderRadius:"2px",padding:"1px 8px", marginRight:"5px",fontSize:"14px", top:"-10px"}}>{"Inactivo"}</div>}
          </div>}
        </div>
      )
  }
}

export default Item